import ReactMarkdown, {
	defaultUrlTransform,
} from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

type TParagraphRendererProps = {
	content?: string;
	children?: React.ReactNode;
	className?: string;
};

export default function ParagraphRenderer({
	content,
	children,
	className = "",
}: TParagraphRendererProps) {
	const urlTransform = (url: string) =>
		url.startsWith("data:")
			? url
			: defaultUrlTransform(url);

	return (
		<ReactMarkdown
			urlTransform={urlTransform}
			remarkPlugins={[remarkGfm]}
			rehypePlugins={[rehypeHighlight, rehypeRaw]}
			components={{
				p: ({ children }) => (
					<p className={`markdown-p ${className}`}>
						{children}
					</p>
				),
				ul: ({ children }) => (
					<ul className="markdown-ul">{children}</ul>
				),
				ol: ({ children }) => (
					<ol className="markdown-ol">{children}</ol>
				),
				li: ({ children }) => (
					<li className="markdown-li">{children}</li>
				),
				pre: ({ children }) => (
					<pre className="markdown-pre">{children}</pre>
				),
				code: ({ children, className: codeClassName, ...props }) => {
					const isInline = !codeClassName;
					if (isInline) {
						return (
							<code className="markdown-inline-code" {...props}>
								{children}
							</code>
						);
					}
					return (
						<code className={codeClassName} {...props}>
							{children}
						</code>
					);
				},
			}}
		>
			{content}
		</ReactMarkdown>
	);
}

